import { pluck, tap } from 'rxjs/operators'
import Component from 'vue-class-component'
import { Watch } from 'vue-property-decorator'

import { Container, ContainerStatus } from '@skinsoft/types'
import { ContainerDataStore } from '@skinsoft/entity/src/container'
import { ReactiveVue } from '@skinsoft/reactive-vue'
import { LocalizedString } from '@skinsoft/ui'
import { ContainerFeaturedCard } from '../../container-featured-card'
import { DELETE_CARD } from '@skinsoft/events'

@Component({
    components: {
        sLocalizedString: LocalizedString,
        sContainerFeaturedCard: ContainerFeaturedCard,
    },
    props: {
        statuses: Array,
        title: String,
        emptyMessage: String,
        query: String,
    },
    template: require('./container-sublist-status.html'),
})
export class ContainerSublistStatus extends ReactiveVue {
    private statuses: ContainerStatus[]
    private title: string
    private emptyMessage: string
    private query: string

    private containers: Container[] = []
    private canSeeMore: boolean = false

    private $containerDataStore: ContainerDataStore

    private static readonly PAGE_SIZE = 20

    private DELETE_CARD = DELETE_CARD

    private mounted() {
        this.subscribeToContainerList()
    }

    private subscribeToContainerList(nextPage: number = 0) {
        this.subscribeTo(
            this.$containerDataStore
                .searchAmongStatusList(
                    this.query,
                    ContainerSublistStatus.PAGE_SIZE,
                    nextPage,
                    this.statuses,
                    { entityFields: ['6024e2dcecfca62afd28daad'], sortAsc: false },
                )
                .pipe(
                    tap(
                        (searchResponse) =>
                            (this.canSeeMore =
                                searchResponse.totalSize >
                                this.containers.length + searchResponse.allData?.length),
                    ),
                    pluck('allData'),
                ),
            (containers) => {
                this.containers = this.containers.concat(containers)
            },
            'containers',
        )
    }

    private get nextPage() {
        return Math.floor(this.containers.length / ContainerSublistStatus.PAGE_SIZE)
    }

    private loadNext() {
        this.unsubscribeFrom('containers')
        this.subscribeToContainerList(this.nextPage)
    }

    private onContainerDeleted(containerId: string) {
        this.$containerDataStore.delete(containerId).subscribe(() => {
            this.containers = []
            this.unsubscribeFrom('containers')
            this.subscribeToContainerList()
        })
    }

    @Watch('query')
    private performSearch() {
        this.unsubscribeFrom('containers')
        this.containers = []
        this.subscribeToContainerList()
    }
}
